<template>
    <div :class="preCls + 'preview-upload'">
        <div :class="preCls + 'preview-upload-' + (showName? 'name' : 'item')"
            v-for="(file, index) in uploadList"
            :key="index">
            <template v-if="file.status === 'finished'">
                <!-- 文字模式 -->
                <template v-if="showName">
                    <Poptip trigger="hover"
                        placement="right"
                        transfer
                        :disabled="readonly || disabled">
                        <span :class="preCls + 'preview-upload-file-name'"
                            @click="handlePreview(file)">
                            <common-icon type="ios-link"
                                :size="14"
                                :color="variables.linkColor"></common-icon>
                            {{file.fileName}}
                        </span>
                        <div class="api"
                            slot="content">
                            <Button v-if="!disabled"
                                @click.native="handleDownLoad(file)"
                                :class="preCls + 'preview-upload-actionBtn mid'">下载</Button>
                            <br />
                            <Button v-if="!readonly && !disabled"
                                @click.native="handleRemove(file)"
                                :class="preCls + 'preview-upload-actionBtn'">删除</Button>
                        </div>
                    </Poptip>
                </template>
                <!-- 预览模式 -->
                <template v-else>
                    <base-img :class="preCls + 'preview-upload-item-img'"
                        :src="file.url"></base-img>
                    <div :class="preCls + 'preview-upload-item-cover'">
                        <Icon v-if="!disabled"
                            :class="preCls + 'preview-upload-item-icon'"
                            type="ios-eye-outline"
                            @click.native="handlePreview(file)"></Icon>
                        <Icon v-if="!disabled"
                            :class="preCls + 'preview-upload-item-icon'"
                            type="md-download"
                            @click.native="handleDownLoad(file)"></Icon>
                    </div>
                    <Icon v-if="!readonly && !disabled"
                        class="is-delete"
                        :class="preCls + 'preview-upload-item-icon'"
                        type="md-close-circle"
                        @click.native="handleRemove(file)"></Icon>
                </template>
            </template>
            <!-- 上传进度提示 -->
            <template v-else>
                <div style="overflow: hidden; width: 100%; height: 100%;">
                    <Progress v-if="file.showProgress"
                        :percent="file.percentage"
                        hide-info></Progress>
                </div>
            </template>
        </div>
        <Upload v-show="!readonly"
            ref="upload"
            name="files"
            type="drag"
            style="display: inline-block;width:58px; height:60px; vertical-align: top; margin-bottom: 8px"
            :show-upload-list="false"
            :default-file-list="arrValue"
            :accept="accept"
            :format="format"
            :disabled="readonly || disabled"
            :max-size="maxSize"
            :with-credentials="true"
            :headers="httpHeaders"
            :data="data"
            :on-success="handleSuccess"
            :on-format-error="handleFormatError"
            :on-exceeded-size="handleMaxSize"
            :before-upload="handleBeforeUpload"
            :multiple="multiple"
            :action="baseURL + action">
            <div style="width: 58px;line-height: 58px;">
                <common-icon :type="uploadIcon"
                    :size="20"></common-icon>
            </div>
        </Upload>
        <!-- 图片预览 -->
        <img-preview ref="imgPreview"
            :urls="imgUrls"
            :current="current"></img-preview>
        <!-- 文件预览 -->
        <a style="display: none;"
            ref="to365"
            target="_blank"
            :href="current"></a>
    </div>
</template>
<script>
import { fileDownload, fileDelete, fileUpload } from '@/api/sys-oss'
import { getCoverImg } from '_u/helper'
import FileExtHelper from '_c/file-ext-helper'
import BaseImg from '../base-img'
import ImgPreview from '../img-preview'

import config from '@/config'
import { getToken, getTarget } from '_u/helper'

function createFile(props) {
    return Object.assign({
        // 后端存取
        id: "", // 文件id
        fileName: "", // 文件名称
        fileType: "", // 文件类型
        fileSize: "", // 文件大小
        path: "", // nginx path
        // 前端所需
        uid: "", // 前端id
        isImg: false, // preview mode
        showProgress: true, // 是否显示进度
        status: "uploading", // 上传状态
        percentage: 0, // 上传进度
        url: "", // 预览url，需配合isImg使用
    }, props)
}

export default {
    name: 'PreviewUpload',
    mixins: [FileExtHelper],
    components: {
        BaseImg,
        ImgPreview,
    },
    props: {
        value: {
            type: [String, Number],
            default: ''
        },
        // 文件大小限制
        maxSize: {
            type: Number,
            default: 51200
        },
        action: {
            type: String,
            default: config.uploadUrl
        },
        // 是否多文件上传
        multiple: {
            type: Boolean,
            default: true
        },
        // 是否只读
        readonly: {
            type: Boolean,
            default: false
        },
        // 是否禁用
        disabled: {
            type: Boolean,
            default: false
        },
        // 文件上传数量
        maxNumber: {
            type: Number,
            default: Infinity
        },
        // 文件格式（后缀）
        format: {
            type: Array,
            default: () => []
        },
        // 文件信息存储格式
        dataFormat: {
            type: String,
            default: 'json',
            validator: value => ['ids', 'json'].some(v => v == value)
        },
        // 上传图标
        uploadIcon: {
            type: String,
            default: 'md-add'
        },
        // 上传时携带的额外数据
        data: {
            type: Object,
            default: () => {}
        },
        // 上传前动作，返回false可阻止上传动作
        beforeUpload: {
            type: Function
        },
        // 延时上传
        lazy: {
            type: Boolean,
            default: false
        },
        //是否显示文件名 若为false显示图片(dataFormat='json'生效)
        showName: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            uploadList: [],
            deletedList: [],
            imgName: '',
            visible: false,
            current: null,
        }
    },

    computed: {
        arrValue() {
            if (this.dataFormat == 'ids') {
                var ids = this.value + ''

                return ids ?
                    ids
                    .split(',')
                    .filter(id => id != '0')
                    .map(id => createFile({
                        id: id,
                        uid: id,
                        isImg: true,
                        showProgress: false,
                        status: "finished",
                        url: this.createPreviewUrl(id),
                    })) : []
            }

            if (this.dataFormat == 'json') {
                var files = JSON.safeParse(this.value + '') || []

                return files.map(v => {
                    Object.assign(v, {
                        uid: v.id,
                        isImg: this.isImg(v.fileType),
                        showProgress: false,
                        status: "finished"
                    })

                    v.url = this.createPreviewUrl(v)

                    return v
                })
            }
        },
        // 路径前缀
        baseURL() {
            return config.baseURL
        },
        token() {
            return getToken()
        },
        target() {
            return getTarget()
        },
        httpHeaders() {
            return process.env.VUE_APP_IDENTITY_AUTH == 'token' ? {
                Authorization: this.token,
                target: this.target
            } : {}
        },
        accept() {
            return this.format.map(v => '.' + v).join(',')
        },
        // 未上传文件，供lazy模式使用
        files() {
            return this.uploadList.filter(v => !v.id).map(v => v.data)
        },
        // 可预览图片数组
        imgUrls() {
            return this.uploadList.filter(v => v.isImg).map(v => v.url)
        },
    },

    model: {
        prop: 'value',
        event: 'input'
    },

    methods: {
        handleRemove(file) {
            this.uploadList.splice(
                this.uploadList.findIndex(v => v.uid == file.uid),
                1
            )

            if (file.id) {
                this.deletedList.push(file)
            }

            if (this.dataFormat == 'ids') {
                this.$emit('input', this.getIds(this.uploadList))
            }

            if (this.dataFormat == 'json') {
                this.$emit('input', this.getJsonFiles())
            }

            this.$emit('on-delete', file)
        },

        handleDownLoad(file) {
            fileDownload(file.id, file.fileName)
        },

        handleSuccess(res, file, fileList) {
            if (res.code == '200') {
                var data = res.data.list[0]

                // 
                file.id = data.id
                file.fileType = data.fileType
                file.fileName = data.fileName
                file.fileSize = data.fileSize
                file.path = data.path
                // 
                file.isImg = this.isImg(file.fileType)
                file.url = this.createPreviewUrl(file)
                file.showProgress = false

                this.$emit('on-upload', file)
            } else {
                // 移除上传失败的文件
                fileList.splice(
                    fileList.findIndex(v => v.uid == file.uid),
                    1
                )
                // 通知
                this.$Notice.warning({
                    title: '上传失败',
                    desc: res.msg
                })
            }

            // 所有文件上传完毕
            if (fileList.filter(v => v.id).length == fileList.length) {
                if (this.dataFormat == 'ids') {
                    this.$emit('input', this.getIds(fileList))
                }

                if (this.dataFormat == 'json') {
                    this.$emit('input', this.getJsonFiles())
                }
            }
        },

        handleFormatError(file) {
            this.$Notice.warning({
                title: '上传失败',
                desc: `${file.name}文件格式不正确（只支持${this.format.join(
                    '、'
                )}）`
            })
        },

        handleMaxSize(file) {
            this.$Notice.warning({
                title: '上传失败',
                desc: `${file.name}体积太大（不能超过${this.maxSize / 1024}M）`
            })
        },

        handleBeforeUpload() {
            var result = true

            // 默认检查
            if (this.multiple) {
                if (this.uploadList.length > this.maxNumber) {
                    this.$Notice.warning({
                        title: '上传失败',
                        desc: '最多上传' + this.maxNumber + '张图片'
                    })

                    result = false
                }
            }

            // 自定义检查
            if (this.beforeUpload) {
                result = this.beforeUpload()
            }

            // 手动模式
            if (this.lazy) {
                if (result) {
                    result = this.lazyValidate(fileObj)
                }
                if (result) {
                    this.lazyUpload(fileObj)
                }

                // 阻止立即上传
                result = false
            } else {
                // 单文件上传做切换
                if (result === true && this.multiple === false) {
                    this.uploadList.shift()
                }
            }

            return result
        },

        handlePreview(file) {
            var ext = this.getExtName(file.fileType)

            // 图片预览
            if (file.isImg) {
                this.current = file.url
                this.$refs.imgPreview.show()
            }
            // 365文件预览，需要开通365白名单
            else if (this.isOffice365(ext) && config.office365 && config.office365.i) {
                this.current = `http://ow365.cn/?i=${config.office365.i}&furl=${getCoverImg(file)}`
                this.$refs.to365.click()
            } else {
                this.$Message.warning({
                    content: `${ext}类型文件不支持预览`,
                })
            }
        },

        createPreviewUrl(file) {
            if (typeof file == 'object') {
                if (file.isImg) {
                    return getCoverImg(file)
                } else {
                    return this.getExtIcon(file.fileType)
                }
            }

            // 只能当成img id来使用
            return getCoverImg(file)
        },

        getIds(list) {
            var ids = list.map(v => v.id).join(',')

            // 后台id使用long类型，无法识别""字符串，只能置为"0"
            if (ids == '') {
                ids = '0'
            }

            return ids
        },

        getJsonFiles() {
            return JSON.stringify(
                // 排除url
                this.uploadList.map(v => ({
                    id: v.id,
                    fileType: v.fileType,
                    fileName: v.fileName,
                    fileSize: v.fileSize,
                    path: v.path,
                }))
            )
        },

        lazyValidate(fileObj) {
            var ext = this.getExtName(fileObj.name)

            // 扩展名校验
            if (!this.format.some(t => t.toLocaleLowerCase() === ext)) {
                this.handleFormatError(fileObj)

                return false
            }
            // 文件大小校验
            if (this.maxSize) {
                if (fileObj.size > this.maxSize * 1024) {
                    this.handleMaxSize(fileObj)

                    return false
                }
            }

            return true
        },

        lazyUpload(fileObj) {
            fileObj.uid = uid++
            // 将有效文件对象加入缓存
            var file = createFile({
                uid: fileObj.uid,
                name: fileObj.name,
                size: fileObj.size,
                isImg: false,
                showProgress: false,
                status: 'finished',
                percentage: 100,
                // 二进制
                data: fileObj,
            })

            var ext = this.getExtName(file.name)
            // 图片转为本地url
            if (this.isImg(ext)) {
                file.url = URL.createObjectURL(fileObj)
            } else {
                file.url = this.getExtIcon(ext)
            }

            if (this.multiple) {
                this.uploadList.push(file)
            } else {
                this.uploadList.splice(0, this.uploadList.length)
                this.uploadList.push(file)
            }
        },

        // 手动上传
        upload() {
            var me = this,
                total = this.files.length

            return new Promise(function(resolve, reject) {
                var count = 0,
                    errors = []

                function complete() {
                    count++
                    // 所有文件上传完毕
                    if (count == total) {
                        if (errors.length > 0) {
                            reject()
                        } else {
                            resolve()
                        }
                    }
                }

                // 多文件上传
                me.files.forEach(fileObj => {
                    var formData = new FormData(),
                        file = me.uploadList.find(v => v.uid == fileObj.uid)

                    if (!file) {
                        complete()
                    }

                    formData.append('files', fileObj)
                    Object.keys(me.data).forEach(k =>
                        formData.append(k, me.data[k])
                    )

                    fileUpload(formData)
                        .then(
                            res => me.handleSuccess(res, file, me.uploadList),
                            err => {
                                errors.push(err)
                                me.handleRemove(file)
                            }
                        )
                        .finally(() => complete())
                })
            })
        },

        // 手动批量删除后端oss文件
        removeDeadFiles() {
            if (this.deletedList.length) {
                return fileDelete(this.deletedList.map(v => v.id).join(","))
                    .then(res => this.deletedList.splice(0, this.deletedList.length))
            }

            return Promise.resolve()
        },
    },

    mounted() {
        var $upload = this.$refs.upload

        this.uploadList = $upload.fileList

        this.$watch(
            function() {
                return $upload.fileList
            },
            function(fileList) {
                this.uploadList = fileList
            }
        )
    }
}
</script>
<style lang="less">
@preview-upload-prefix-cls: ~'ivu-preview-upload';

.@{preview-upload-prefix-cls} {
    line-height: 0;

    &-item {
        display: inline-block;
        width: 60px;
        height: 60px;
        text-align: center;
        line-height: 58px;
        border: 1px solid transparent;
        border-radius: 4px;
        background: #fff;
        position: relative;
        box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
        margin: 0 8px 8px 0;

        &:hover &-cover {
            display: block;
        }

        &:hover .is-delete {
            display: block;
        }

        &-img {
            width: 100%;
            height: 100%;
        }

        &-cover {
            display: none;
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            background: rgba(0, 0, 0, 0.6);
        }

        &-icon {
            color: #fff;
            font-size: 20px;
            cursor: pointer;
            margin: 0 2px;

            &.is-delete {
                display: none;
                font-size: 18px;
                color: #000;
                background: #fff;
                border-radius: 50%;
                position: absolute;
                right: -9px;
                top: -9px;
            }
        }
    }

    &-name {
        display: inline-block;
        min-width: 60px;
        height: 60px;
        line-height: 60px;
        margin: 0 10px;
    }

    &-file-name{
        cursor: pointer;

        &:hover{
            color: @primary-color;
        }
    }

    &-actionBtn {
        width: 100px;

        &.mid {
            margin: 5px 0;
        }
    }
}
</style>
